import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-horoscope-card',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './horoscope-card.component.html',
  styleUrl: './horoscope-card.component.scss'
})
export class HoroscopeCardComponent {

}
